<template>
  <section class="case-study-summary-card border rounded overflow-hidden">
    <div
      @click.stop="logoFocused = !logoFocused"
      v-if="caseStudy.customer_logo_url"
      :class="{ pointer: editable }"
      class="case-study-summary-card__logo d-flex justify-content-center"
    >
      <div
        v-if="logoFocused && editable"
        @click.stop="deleteLogoImage"
        class="controls border rounded bg-white position-absolute d-flex align-items-center justify-content-center"
      >
        <b-icon icon="trash-fill" />
      </div>

      <img :style="{ width: '80%' }" :src="caseStudy.customer_logo_url" />
    </div>

    <div class="case-study-summary-card__data d-flex flex-column">
      <div class="description d-flex">
        {{ caseStudy.company_description }}
      </div>

      <div class="case-study-summary-card__data__info-points d-flex flex-column">
        <div v-for="(data, idx) in caseStudy.company_data" class="d-flex flex-column" :key="idx">
          <div>
            <span
              :name="`title-` + idx"
              @blur="updateSection"
              :contenteditable="editableText"
              class="title font-weight-bold"
            >
              {{ data.title }}
            </span>
          </div>
          <div>
            <span
              :name="`value-` + idx"
              @blur="updateSection"
              :contenteditable="editableText"
              class="data mt-1"
            >
              {{ data.value }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script lang="ts">
import { useCaseStudyStore } from '@app/stores/CaseStudyStore'

export default {
  props: {
    editable: { type: Boolean, required: true },
    caseStudy: { type: Object, required: true },
  },
  data() {
    return {
      logoFocused: false,
    }
  },
  computed: {
    editableText() {
      return this.editable ? true : null
    },
  },
  methods: {
    updateSection(event) {
      const el = event.target
      const fieldName = el.getAttribute('name').split('-')[0]
      const idx = el.getAttribute('name').split('-')[1]
      const newValue = el.innerText

      const newData = { ...this.caseStudy }
      newData.company_data[idx][fieldName] = newValue

      useCaseStudyStore().updateCaseStudy(newData)

      el.blur()
    },
    deleteLogoImage() {
      useCaseStudyStore()
        .removeCustomerLogo(this.caseStudy.id)
        .then((response) => {
          useCaseStudyStore().upsertCaseStudy(response.data.case_study)
        })
        .catch(() => {
          this.$toast('Failed to remove logo. ❌', { variant: 'danger' })
        })
        .finally(() => {
          this.logoFocused = !this.logoFocused
        })
    },
  },
}
</script>

<style lang="sass" scoped>

.pointer
  cursor: pointer

.description
  font-size: 16px
  margin-bottom: 8px

.controls
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1)
  height: 45px
  width: 40px
  z-index: 10
  margin-top: -10px
  margin-right: 255px
  cursor: pointer

.case-study-summary-card
  background: #F8F9FA

  &__logo
    padding: 24px 8px
    background: white

  &__data
    color: #6C757D
    padding: 8px 16px
    background: #F8F9FA

    &__info-points
      margin-bottom: 8px
      gap: 16px

      .title
        color: black
        font-size: 18px

        &:focus
          outline: 2px solid var(--uePurple)
          outline-offset: 2px

      .data
        font-size: 16px

        &:focus
          outline: 2px solid var(--uePurple)
          outline-offset: 2px
</style>
